import { combineReducers } from 'redux';
import { authReducer } from './authReducer';
import { userSelectionsReducer } from './userSelectionsReducer';

// Import and add here reducers to automatically bind them to the store on startup 
export default combineReducers({
  auth: authReducer,
  userSelections: userSelectionsReducer
})
